import React, { useCallback } from "react";
import { Linking, StyleSheet, Text, type StyleProp, type TextStyle } from "react-native";
import { useTranslation } from "react-i18next";

import { useAppConfig } from "../../AppConfigProvider";
import { colors, semanticColors, typographyStyles } from "../../styles/design-system";

interface CompanionDisclaimerTextProps {
  style?: StyleProp<TextStyle>;
}

function CompanionDisclaimerText({ style }: CompanionDisclaimerTextProps) {
  const appConfig = useAppConfig();
  const { t } = useTranslation();
  const termsOfServiceLink = appConfig?.termsOfServiceLink?.trim();
  const termsText = t("text.ai_tutor_chat_terms_link");

  const handleTermsPress = useCallback(() => {
    if (!termsOfServiceLink) {
      return;
    }

    void Linking.openURL(termsOfServiceLink);
  }, [termsOfServiceLink]);

  return (
    <Text style={[styles.disclaimerText, style]}>
      {t("text.ai_tutor_chat_disclaimer")}{" "}
      {termsOfServiceLink ? (
        <Text
          role="link"
          accessibilityRole="link"
          accessibilityLabel={t("text.ai_tutor_chat_terms_accessibility_label")}
          onPress={handleTermsPress}
          style={styles.termsLink}>
          {termsText}
        </Text>
      ) : (
        <Text>{termsText}</Text>
      )}
    </Text>
  );
}

const styles = StyleSheet.create({
  disclaimerText: {
    ...typographyStyles.textXs,
    color: semanticColors.typography.textLight,
    textAlign: "center",
  },
  termsLink: {
    color: colors.blue[600],
    textDecorationLine: "underline",
  },
});

export default CompanionDisclaimerText;
